import { axiosRef } from '../../../api';
import { formatDateWithDashes } from '../../../utils/helper';
import { mapShipmentToStatus } from '../functions';
import {
  AdminShipment,
  GeneralShipment,
  GeneralShipmentsQueryPayload,
} from '../interfaces';

export default async function getShipments(
  payload: GeneralShipmentsQueryPayload,
  setLoading: (loading: boolean) => void,
  isAdmin: boolean,
) {
  let url = `${isAdmin ? '/admin' : ''}/shipments?shipment_status=0&`;
  const emptyResponse = {
    shipments: [],
    count: 0,
    pages: 0,
  };

  if (payload && payload?.subAccountNumber) {
    url += `account=${payload?.subAccountNumber}&`;
  }
  if (payload && payload.shipmentStartDate && payload.shipmentEndDate) {
    const start = formatDateWithDashes(payload.shipmentStartDate);
    const end = formatDateWithDashes(payload.shipmentEndDate);
    url += `start_date=${start}&end_date=${end}&`;
  } else {
    return emptyResponse;
  }
  if (payload && payload.userEmail && payload.userEmail !== '') {
    url += `username=${payload.userEmail}&`;
  }
  if (payload && payload.selectedJob) {
    url += `gateway_number=${payload.selectedJob}&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url += `search=${payload.search}&`;
  }

  setLoading(true);
  try {
    const response = await axiosRef.get(url);

    if (!response?.data?.is_error) {
      setLoading(false);
      const shipments = response.data.content.data.map(
        (datum: any): GeneralShipment | AdminShipment => ({
          id: datum?.id,
          creationDate: datum?.creation_date,
          shipmentId: datum?.shipment_id,
          userEmail: datum?.username,
          originCity: datum?.origin?.city,
          destinationCity: datum?.destination?.city,
          reference1: datum?.reference_one,
          reference2: datum?.reference_two,
          status: mapShipmentToStatus(datum),
          ffNumber: datum?.ff_number,
        }),
      );
      return {
        shipments,
        count: response.data.content.count,
        pages: response.data.content.pages,
      };
    }
    setLoading(false);
    return emptyResponse;
  } catch (error) {
    setLoading(false);
    return emptyResponse;
  }
}
